import { render, staticRenderFns } from "./DevNew.vue?vue&type=template&id=588fc612&scoped=true"
import script from "./DevNew.vue?vue&type=script&lang=js"
export * from "./DevNew.vue?vue&type=script&lang=js"
import style0 from "./DevNew.vue?vue&type=style&index=0&id=588fc612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fc612",
  null
  
)

export default component.exports